import React, { useState, useEffect } from "react";
import loginToken from "../../authComponents/localStorageItems/LoginTokin";
import baseURL from "../../authComponents/baseURL/BaseURL";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  MdMarkEmailUnread,
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import logo from "../../../assets/favicon.ico.jpg";
import { IoLogOutOutline } from "react-icons/io5";
import { CiSettings } from "react-icons/ci";
import { RiDashboardLine, RiUserReceived2Fill } from "react-icons/ri";
import { BiWorld } from "react-icons/bi"; // For Countries
import { GiModernCity } from "react-icons/gi"; // For Cities
import { TbMapPin } from "react-icons/tb";
const Menu = [
  {
    icon: <RiDashboardLine />,
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    icon: <RiUserReceived2Fill />,
    title: "Users",
    to: "/admin/users",
  },
  {
    icon: <MdMarkEmailUnread />,
    title: "Emails",
    to: "/admin/emails",
  },
  {
    icon: <BiWorld />,
    title: "Countries",
    to: "/admin/countries",
  },
  {
    icon: <TbMapPin />,
    title: "States",
    to: "/admin/states",
  },
  {
    icon: <GiModernCity />,
    title: "Cities",
    to: "/admin/cities",
  },
];

const AdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const toggleSideBar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    window.location.reload();
  };
  const [userRole, setUserRole] = useState("");
  useEffect(() => {
    const getRole = async () => {
      try {
        const response = await baseURL.get("/profile", {
          headers: {
            Authorization: `Bearer ${loginToken}`,
          },
        });
        if (response.data.data.role !== "admin") {
          navigate("/");
        }
        setUserRole(response.data.data.role);
      } catch (error) {
        console.error(error);
      }
    };

    if (loginToken) {
      getRole();
    } else {
      navigate("/");
    }
  }, []);

  return (
    <>
      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-screen transition-transform bg-white shadow-lg ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 w-56 z-40`}
      >
        <div className="h-full p-2 flex flex-col">
          <Link to="/">
            <div className="flex items-center px-4 py-5 border-b">
              <img
                src={logo}
                alt="Logo"
                className="w-50 h-50 rounded-full"
              />
            </div>
          </Link>

          <ul className="flex-1 mt-4">
            {Menu.map((item, index) => (
              <li key={index} className="mb-1 font-serif">
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `${
                      isActive
                        ? "bg-[#730000] text-white"
                        : "text-gray-600 hover:bg-gray-100"
                    } flex items-center px-4 py-3 transition rounded-lg font-serif`
                  }
                >
                  <span className="text-xl">{item.icon}</span>
                  <span className="ml-3 font-medium font-serif">
                    {item.title}
                  </span>
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="px-4 py-5 border-t">
            <button
              onClick={handleLogout}
              className="w-full flex items-center text-gray-600 hover:text-[#730000]"
            >
              <IoLogOutOutline className="text-xl font-serif" />
              <span className="ml-3 font-medium font-serif">Logout</span>
            </button>
          </div>
        </div>
      </aside>

      {/* Sidebar Toggle Button */}
      <button
        onClick={toggleSideBar}
        className="fixed top-12 left-4 z-50 p-2 bg-[#730000] text-white rounded-full shadow-md md:hidden"
      >
        {isSidebarOpen ? (
          <MdOutlineKeyboardArrowLeft size={20} />
        ) : (
          <MdOutlineKeyboardArrowRight size={20} />
        )}
      </button>

      {/* Main Content */}
      <div
        className={`min-h-screen bg-gray-50 transition-all ${
          isSidebarOpen ? "hidden md:block" : "block"
        } md:ml-56`}
      >
        {/* Header */}
        <header className="bg-white shadow-md p-4 flex items-center justify-between font-serif">
          <h1 className="text-xl font-semibold text-gray-700 font-serif">
            Welcome, Admin
          </h1>
          <Link to="/admin/settings">
            <CiSettings className="text-2xl text-gray-500 cursor-pointer hover:text-[#730000]" />
          </Link>
        </header>

        {/* Page Content */}
        <main className="p-6 font-serif">{children}</main>
      </div>
    </>
  );
};

export default AdminLayout;
